import { connect } from 'react-redux';
import { change as changeFormvalue } from 'redux-form';
import { FLEXIBLE_TICKET } from '../../products';
import { getTravelerNames } from '../../common/utils/travelerNames';
import { getSelected } from '../utils/selection';
import FlexibleTicket from '../components/FlexibleTicket';
const mapStateToProps = (state, {
  form,
  order
}) => ({
  initialState: getSelected(FLEXIBLE_TICKET.name, form)(state),
  travelerNames: getTravelerNames(form, state, order.travelers)
});
const mapDispatchToProps = (dispatch, {
  form
}) => ({
  onModalConfirm: selectedOptions => dispatch(changeFormvalue(form, `${FLEXIBLE_TICKET.name}.value`, selectedOptions))
});
export default connect(mapStateToProps, mapDispatchToProps)(FlexibleTicket);
//# sourceMappingURL=FlexibleTicketContainer.js.map